import { TextField } from '@mui/material';

const FocusableTextField = (props) => {
    return <TextField {...props} onFocus={(e) => e.target.select()} />;
};

export default FocusableTextField;
